import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "bg-grey-2 q-pa-md rounded-borders"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_access_token_login = _resolveComponent("access-token-login")!
  const _component_message = _resolveComponent("message")!
  const _component_client_actions = _resolveComponent("client-actions")!
  const _component_accounts_list = _resolveComponent("accounts-list")!
  const _component_guest_layout = _resolveComponent("guest-layout")!

  return (_openBlock(), _createBlock(_component_guest_layout, { style: {"max-width":"1000px"} }, {
    default: _withCtx(() => [
      (_ctx.accounts === undefined || _ctx.actionAccounts.length > 0)
        ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Please Import Your Social Posts ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_access_token_login, {
        "access-token": _ctx.accessToken,
        onLoggedIn: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loggedIn = true)),
        onExpired: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpired = true))
      }, null, 8, ["access-token"]),
      (_ctx.isExpired)
        ? (_openBlock(), _createBlock(_component_message, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(" This link has expired. Please check your email inbox for a more recent link. ")
            ]),
            _: 1
          }))
        : (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.accounts === undefined || _ctx.actionAccounts.length)
                ? (_openBlock(), _createBlock(_component_accounts_list, {
                    key: 0,
                    "client-id": _ctx.clientId,
                    platforms: _ctx.actionPlatforms,
                    "onUpdate:platforms": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actionPlatforms) = $event)),
                    accounts: _ctx.accounts,
                    platform: _ctx.platform,
                    "onUpdate:platform": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.platform) = $event)),
                    "onUpdate:accounts": _ctx.setAccounts
                  }, {
                    default: _withCtx(({ account }) => [
                      (account && !_ctx.finishedIds.includes(account.id))
                        ? (_openBlock(), _createBlock(_component_client_actions, {
                            key: 0,
                            account: account
                          }, null, 8, ["account"]))
                        : (account && _ctx.finishedIds.includes(account.id))
                          ? (_openBlock(), _createBlock(_component_message, {
                              key: 1,
                              class: "q-ma-md"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Your " + _toDisplayString(account.socialSite.name) + " posts are importing. No further action is needed for " + _toDisplayString(account.socialSite.name) + ". ", 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["client-id", "platforms", "accounts", "platform", "onUpdate:accounts"]))
                : (_openBlock(), _createBlock(_component_message, {
                    key: 1,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Currently, you do not need to import any posts."),
                      _hoisted_2,
                      _createTextVNode("No further action is required by you. ")
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}